/**
 * @generated SignedSource<<fea4f5d11c8576c9dd9e08d112180566>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psOrder",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatusIn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psOrderIn",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentSourceUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePaymentSourceTPayload",
        "kind": "LinkedField",
        "name": "updatePaymentSourceTByPsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "paymentSourceT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentSourceUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePaymentSourceTPayload",
        "kind": "LinkedField",
        "name": "updatePaymentSourceTByPsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "paymentSourceT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cff955a00e579e07ef9b4ecb892d98c",
    "id": null,
    "metadata": {},
    "name": "PaymentSourceUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentSourceUpdateMutation(\n  $input: UpdatePaymentSourceTByPsIdInput!\n) {\n  updatePaymentSourceTByPsId(input: $input) {\n    paymentSourceT {\n      psId\n      psStatus\n      psOrder\n      psStatusIn\n      psOrderIn\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "317267e1aa394524fd7e1144fa08332b";

module.exports = node;
